export default class InjectionProperty {

    /**
     * @param {string} name
     * @param {any} value
     * @param {string} type
     * @param {any?} rawValue
     */
    constructor(name, value, type, rawValue) {
        this.name = name;
        this.value = value;
        this.type = type;
        this.rawValue = rawValue;
    }

    /** @returns {boolean} */
    isRawProperty(){
        return this.type === InjectionProperty.TYPE.RAW;
    }

    /** @returns {boolean} */
    isOverriddenProperty(){
        return this.type === InjectionProperty.TYPE.OVERRIDDEN;
    }

    /** @returns {boolean} */
    isUserDefinedProperty(){
        return this.type === InjectionProperty.TYPE.USER_DEFINED;
    }

    /** @returns {InjectionProperty} */
    static empty () {
        return new InjectionProperty("", "", InjectionProperty.TYPE.USER_DEFINED)
    }

    /**
     * @param {{[key: string]: string}[]} json
     * @returns {InjectionProperty[]}
     */
    static parseServerJsonMany(json){
        const result = [];
        for (const key in json) {
            result.push(new InjectionProperty(key, json[key]))
        }
        return result;
    }

    static TYPE = {
        RAW: "RAW",
        USER_DEFINED: "USER_DEFINED",
        OVERRIDDEN: "OVERRIDDEN"
    };
}
